import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowRightFromLine: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M3 5v14' }],
    ['path', { d: 'M21 12H7' }],
    ['path', { d: 'm15 18 6-6-6-6' }],
  ],
];

export default ArrowRightFromLine;
